<footer id="footer"
  class="footer footer--unit-player-navigation grid-container grid-container-padded flex-container align-justify"
  [ngClass]="hideTheFooter ? 'hide-for-mobile' : ''"
>
  <button
    [disabled]="disableNavPrevious"
    (click)="previousButtonClicked($event)"
    class="button clear underline button--icon-on-left text-uppercase large-text"
  >
    <svg
      class="icon icon--arrow-left icon--secondary"
      *ngIf="previousButtonIcon === 'arrow-left'"
    >
      <use xlink:href="#icon-arrow-left" href="#icon-arrow-left"></use>
    </svg>
    <svg
      class="icon icon--restart icon--secondary icon--material"
      *ngIf="previousButtonIcon === 'start-again'"
    >
      <use xlink:href="#icon-restart" href="#icon-restart"></use>
    </svg>
    <span *ngIf="restartButtonText">{{ restartButtonText }}</span>
    <span *ngIf="!restartButtonText">Previous</span>
  </button>
  <button
    [disabled]="!canProgress || showLoader"
    (click)="progressButtonClicked($event)"
    class="button primary button--icon-on-right text-uppercase with-shadow width-auto"
  >
    <span *ngIf="!showLoader">{{ progressButtonText }}</span>
    <span *ngIf="showLoader">{{ progressLoadingButtonText }}</span>
    <span *ngIf="showLoader">
      <mono-common-loading-animation></mono-common-loading-animation>
    </span>
    <svg
      class="icon icon--arrow-right icon--light"
      *ngIf="!showLoader && progressButtonIcon === 'arrow-right'"
    >
      <use xlink:href="#icon-arrow-right" href="#icon-arrow-right"></use>
    </svg>
    <svg
      class="icon icon--checkmark icon--light"
      viewBox="0 0 24 24"
      style="width: 20px; height: 20px;"
      *ngIf="!showLoader && progressButtonIcon === 'checkmark'"
    >
      <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
    </svg>
  </button>
</footer>
